<!-- Staff Pictures -->
<div class="pull-right" *ngIf="staffPictureBase64 && !useCourse">
    <img style="height: 85px; margin-top: 5px; margin-right: 10px; float: left;"
        [src]="resourceSrc()" />
</div>

<!-- Header -->
<div mat-dialog-title>
    <div role="heading" 
        *ngIf="useCourse" 
        translate>
		Class Information
    </div>
    <div role="heading" 
        *ngIf="!useCourse" 
        translate>
		Teacher Profile
	</div>
	<div *ngIf="!useCourse"
		style="color: rgba(0, 0, 0, 0.87); font-weight: normal; font-size: 16px;">
		{{teacherName}}
	</div>
</div>

<!-- Body -->
<mat-dialog-content [ngStyle]="{'height': profiles && profiles.length > 0 ? '65vh' : ''}">

    <!-- Class Information -->
    <div *ngIf="useCourse">
        <table>
            <tr>
                <td translate>Course Name</td>
                <td>{{courseName ? courseName : ''}}</td>
            </tr>
            <tr>
                <td translate>Course-Section</td>
                <td>{{courseSection ? courseSection : ''}}</td>
            </tr>
            <tr>
                <td translate>School</td>
                <td>{{school ? school : ''}}</td>
            </tr>
            <tr>
                <td translate>Teacher</td>
                <td>
                    {{teacherName ? teacherName : ''}}
                    <a *ngIf="showTeacherProfileLink"
                        (click)="teacherProfileClick.emit()"
                        style="padding-left: 20px; cursor: pointer;">
                        Teacher Profile
                    </a>
                </td>
            </tr>
        </table>
    </div>

    <!-- The Profile Table -->
    <profile-table *ngIf="profiles"
        [profiles]="profiles"
        [userCanEdit]="false"
        [expandCollapseEvent]="expandEmitter"
        [isViewing]="true"
		[borderBottom]="false"
		[enforceDates]="true"></profile-table>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions class="sis-app-footer" style="position: sticky">
    
    <!-- Left Buttons -->
    <expand-collapse-buttons *ngIf="profiles && profiles.length > 0"
        [expandEmitter]="expandEmitter"></expand-collapse-buttons>

    <!-- Right Buttons -->
    <div class="footerRight">
        <tyl-button image="Cancel.png" label="Close" (clickEvent)="close()"></tyl-button>
    </div>
</mat-dialog-actions>